export const WORLD_ZOOM_MIN = 0.65;
export const WORLD_ZOOM_MAX = 1.8;

export function clampWorldZoom(value: number, minimum = WORLD_ZOOM_MIN): number {
  if (!Number.isFinite(value)) return 1;
  return Math.max(minimum, Math.min(WORLD_ZOOM_MAX, value));
}

export function zoomFromWheel(current: number, deltaY: number, minimum = WORLD_ZOOM_MIN): number {
  return clampWorldZoom(current * Math.exp(-deltaY * 0.0015), minimum);
}

export function zoomFromPinch(startZoom: number, startDistance: number, currentDistance: number, minimum = WORLD_ZOOM_MIN): number {
  if (startDistance <= 0 || currentDistance <= 0) return clampWorldZoom(startZoom, minimum);
  return clampWorldZoom(startZoom * currentDistance / startDistance, minimum);
}
